import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class InfoService extends RLBaseService {
    
        static $inject = ["$resource", "$q"];
        constructor(private $resource: ng.resource.IResourceService, private $q: ng.IQService) {
            super($resource);
        }
    
        getRecentActivities(count: number = 5, self: boolean = false) {
            var data = {
                count: count,
                self: self
            };
            return this.toRLService<Models.RecentActivityItem>("/api/info/getrecentactivities").query(data).$promise;
        }

        getUserNotificationsCount( status: string, charTypeIDs: string, sortColumn: string, sortDirection: string) {
            var data = {
                status: status,
                charTypeIDs: charTypeIDs,
                sortColumn: sortColumn,
                sortDirection: sortDirection
            };
            return this.toRLService<{ success: boolean, data: number }>("/api/info/usernotificationscount").post(data).$promise;
        }
    
        getUserNotifications(start: number, count: number, status: string, charTypeIDs: string, sortColumn: string, sortDirection:string) {
            var data = {
                start: start,
                count: count,
                status: status,
                charTypeIDs: charTypeIDs,
                sortColumn: sortColumn,
                sortDirection: sortDirection
            };
            return this.toRLService<Models.UserNotification>("/api/info/getusernotifications").query(data).$promise;
        }
    
        setNotificationStatus(notificationIDs: number[], status: string) {
    
            return this.toRLService<{ success: boolean, data: number }>("/api/info/setnotificationstatus").post({ id: notificationIDs, status: status }).$promise;
        }


        setAllNotificationsToReadStatus(charTypeIDs) {
            var data = {
                charTypeIDs: charTypeIDs
            };
            return this.toRLService<{ success: boolean, data: number }>("/api/info/setallnotificationstoreadstatus").post(data).$promise;
        }

        getEntityStatusCounts(templateID: number, charTypeID: number) {
            var data = {
                templateID: templateID,
                charTypeID: charTypeID
            };
            return this.toRLService<Models.IKeyValuePair<string, number>>("/api/info/getentitystatuscounts").query(data).$promise;
        }
    
        keepAlive() {
            return this.toRLService<void>("/api/info/keepalive").get().$promise;
        }
    }